<template>
    <div>
		<template v-if="merchantPayments === true">
            <div class="modal fade" id="transfer" tabindex="-1" role="dialog" aria-labelledby="transferLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body transfer-payment-popup text-left p-4">
                            <div class="popup-head line-head">
                                <h2 class="pb-2"> Payment Transfer To </h2>
                            </div>
                            <div class="row normal-ib-space mt-3" v-if="company != null">
                                <div class="col-md-12 mb-3">
                                    <table width="100%" v-if="company.default_beneficiary != null">
                                        <tr>
                                            <td> Account Type </td>
                                            <td> {{company.default_beneficiary.account_type}} </td>
                                        </tr>
                                        <tr>
                                            <td> Bank </td>
                                            <td> {{company.default_beneficiary.bank_name}} </td>
                                        </tr>
                                        <tr>
                                            <td> Account Number </td>
                                            <td> {{company.default_beneficiary.account_number}} </td>
                                        </tr>
                                        <tr>
                                            <td> Account Title </td>
                                            <td> {{company.default_beneficiary.account_title}} </td>
                                        </tr>
                                    </table>
                                    <table width="100%" v-else>
                                        <tr>
                                            <td> Bank Detail </td>
                                            <td> Not found </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close"> Cancel </button> </div>
                                <div class="col"> <button class="btn btn-primary active" v-if="company.default_beneficiary != null" :disabled="proceedButton" @click="proceedMerchantPayment()"> Proceed </button> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Login Modal End-->
            <div class="clearfix">
                <div class="row mb-3">
                    <div class="col-md-12">
                        <div class="row top-widgets-row align-bottom">
                            <div class="col-md-3 widgets-col">
                                <div class="payroll-counter-box">
                                    <div class="top-box no-bg">
                                        <span class="title" title="7"> <em class="rollover"> {{formatAmount(total_payment_recevied)}} </em> </span>
                                        <p> Payment Recieved </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                            <div class="col-md-3 widgets-col">
                                <div class="payroll-counter-box">
                                    <div class="top-box no-bg">
                                        <span class="title" title="7"> <em class="rollover"> {{formatAmount(total_transfered)}} </em> </span>
                                        <p> Transfered </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                            <div class="col-md-3 widgets-col">
                                <div class="payroll-counter-box">
                                    <div class="top-box no-bg">
                                        <span class="title" title="250000k"> {{formatAmount(total_balance)}} </span>
                                        <p> Balance </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                            <div class="col-md-3 widgets-col">
                                <div class="transfer-cta">
                                    <span class="label"> Transfer Payment </span>
                                    <button class="btn btn-primary active" data-toggle="modal" data-target="#transfer" :disabled="transferButton"> Transfer </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="autogenerate-content">
                    <table id="myMerchantPaymentList" class="table">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Trx ID</th>
                                <th>Company Name</th>
                                <th>Amount</th>
                                <th>Purpose Of Payment</th>
                                <th>Transfered</th>
                                <th>Transfered To</th>
                                <th>Account Number</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
		</template>
        <template v-else-if="merchantPayments === null"><preLoader></preLoader></template>
		<template v-else-if="merchantPayments === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    var merchantTable = null;
    export default {
        data() {
             return {
                company : null,
                total_balance : 0,
                total_payment_recevied : 0,
                total_transfered : 0,
                merchantPayments : null,
                transferButton : true,
                proceedButton : false,
                paymentIds : []
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('my_merchant_payments').then(result => {
                this.merchantPayments = result.my_merchant_payments;
            }).then(result => {
                if(this.merchantPayments == true){
                    this.myMerchantPaymentList();
                }
            });
            $('#myMerchantPaymentList').on('click', 'input[type="checkbox"]', function() {
            });
        },
        methods: {
            proceedMerchantPayment(){
                this.proceedButton = true;
                axios.post('api/merchantPaymentProceed',{'paymentIds':this.paymentIds}).then(res => {
                    if(res.status == 200){
                        this.showToastBox(res.data.msgType,res.data.msg);
                        window.location.reload();
                    }else{
                        this.showAlertBox('error','Some problem in your form data');
                    }
                    this.$Progress.finish();
                }).catch(err => {
                    this.showAlertBox('error','Some problem in your form data');
                });

            },
            myMerchantPaymentList: function(){
                var that = this;
                merchantTable = $('#myMerchantPaymentList').DataTable({
                    "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    select: true,
                    columnDefs: [ {
                        orderable: false,
                        className: 'select-checkbox',
                        targets:   0
                    } ],
                    select: {
                        style:    'multi',
                        selector: 'td:first-child'
                    },
                    order: [[ 1, 'asc' ]],
                    processing: true,
                    serverSide: true,
                    searching: false,
                    ajax: {
                        "url": "api/getMyMerchantPaymentList",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.total_payment_recevied = json.responseJSON.total_payment_recevied;
                                that.total_balance = json.responseJSON.total_balance;
                                that.total_transfered = json.responseJSON.total_transfered;
                                that.company = json.responseJSON.company;
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', "mData": "id",'render':function(data,type,full){
                            var transfered = full['transfered'];
                            var html = '---';
                            if(transfered == 'NO'){
                                html = '<input type="checkbox" id="'+full['id']+'" value="'+full['id']+'">';
                            }
                            return html;
                        }},
                        {data: 'transaction_id'},
                        {data:"payer_company_name"},
                        {data:"amount","mData": "amount","render": $.fn.dataTable.render.number(',')},
                        {data:"reason"},
                        {data:"transfered"},
                        {data: 'account_title', "mData": "account_title",'render':function(data,type,full){
                            var transfered = full['transfered'];
                            var html = '---';
                            if(transfered == 'YES'){
                                html = full['beneficiary']['account_title'];
                            }
                            return html;
                        }},
                        {data: 'account_number', "mData": "account_number",'render':function(data,type,full){
                            var transfered = full['transfered'];
                            var html = '---';
                            if(transfered == 'YES'){
                                html = full['beneficiary']['account_number'];
                            }
                            return html;
                        }},
                    ],
                });
                $(document).ready(function(){
                    merchantTable.on( 'select', function ( e, dt, type, indexes ) {
                        var data = merchantTable.rows('.selected').data();
                        that.paymentIds = [];
                        for(var i = 0; i < data.length; i++){
                            var user = data[i];
                            var value = user['id'];
                            that.paymentIds.push(value);
                        }
                        that.transferButton = (that.paymentIds.length > 0) ? false : true;
                    } );
                    merchantTable.on( 'deselect', function ( e, dt, type, indexes ) {
                        var data = merchantTable.rows( indexes ).data();
                        var id = data[0]['id'];
                        that.paymentIds.splice( $.inArray(id,that.paymentIds), 1);
                        that.transferButton = (that.paymentIds.length > 0) ? false : true;
                    });
                })
            },
        },
        created() {
        }
    }
</script>
